module.exports = "/_next/static/images/storyblok-b8c29575991771b67a7ab704896ca0bc.png";